import { gql } from '@apollo/client';

export default gql`
  mutation emailTickets(
    $bookingReference: String!
    $passengerLastName: String!
    $emails: [String!]
    $passengerIds: [String!]
    $market: String
  ) {
    emailTickets(
      bookingReference: $bookingReference
      passengerLastName: $passengerLastName
      emails: $emails
      passengerIds: $passengerIds
      market: $market
    ) {
      success
    }
  }
`;
